import React from 'react';
import styled from 'styled-components';

const Icon = styled.i`
  font-size: 22px;
`;

const SearchIcon: React.FC = () => {
  return <Icon className="fa fa-search fa-lg" aria-hidden="true"></Icon>;
};

export default SearchIcon;
